import React from 'react';

export const ControlsCycle = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="40" viewBox="0 0 24 40">
    <g fill="none" fillRule="evenodd">
      <g fill="#5B2F91">
        <path
          d="M15.53 15.059c2.729 0 4.94 2.212 4.94 4.941 0 2.687-2.144 4.873-4.815 4.94l-.126.001h-.414l.914.913c.259.26.274.67.045.948l-.045.05c-.26.26-.671.275-.948.046l-.05-.046-2.118-2.118c-.43-.43-.15-1.156.439-1.202l.06-.003h2.117c1.95 0 3.53-1.58 3.53-3.529 0-1.913-1.522-3.47-3.422-3.528l-.108-.001h-1.411c-.39 0-.706-.316-.706-.706 0-.37.283-.673.645-.704l.06-.002h1.412zm-6.61-1.957l.05.046 2.117 2.118c.43.43.15 1.156-.439 1.202l-.06.003H8.471c-1.95 0-3.53 1.58-3.53 3.529 0 1.913 1.522 3.47 3.422 3.528l.108.001h1.411c.39 0 .706.316.706.706 0 .37-.283.673-.645.704l-.06.002H8.47c-2.73 0-4.942-2.212-4.942-4.941 0-2.687 2.145-4.873 4.816-4.94l.126-.001h.413l-.913-.913c-.259-.26-.274-.67-.045-.948l.045-.05c.26-.26.671-.275.948-.046z"
          transform="translate(-442 -881) translate(442 879) translate(0 2)"
        />
      </g>
    </g>
  </svg>
);
